import type { OpenDepositPopupOptions } from "./DepositPopup.types";

export const DEPOSIT_POPUP_EVENT = "show-deposit-popup";
export const CLOSE_DEPOSIT_POPUP_EVENT = "close-deposit-popup";

export const openDepositPopup = (options?: OpenDepositPopupOptions) => {
  window.dispatchEvent(
    new CustomEvent(DEPOSIT_POPUP_EVENT, {
      detail: options || {},
    })
  );
};

export const closeDepositPopup = () => {
  window.dispatchEvent(new CustomEvent(CLOSE_DEPOSIT_POPUP_EVENT));
};
